import readme from "@docs/README.md?raw";
import acquisitionReadme from "@docs/acquisition/README.md?raw";
import acquisitionAdmin from "@docs/acquisition/admin.md?raw";
import acquisitionStaff from "@docs/acquisition/staff.md?raw";
import acquisitionPatron from "@docs/acquisition/patron.md?raw";
import catalogReadme from "@docs/catalog/README.md?raw";
import circulationReadme from "@docs/circulation/README.md?raw";
import publicOpacGuide from "@docs/PUBLIC_OPAC_API_INTEGRATION_GUIDE.md?raw";

export type DocEntry = { path: string; title: string; markdown: string };

export const DOC_INDEX: DocEntry[] = [
  { path: "", title: "Documentation home", markdown: readme },
  { path: "acquisition", title: "Acquisitions overview", markdown: acquisitionReadme },
  { path: "acquisition/admin", title: "Acquisitions — Administrators", markdown: acquisitionAdmin },
  { path: "acquisition/staff", title: "Acquisitions — Staff", markdown: acquisitionStaff },
  { path: "acquisition/patron", title: "Acquisitions — Patrons", markdown: acquisitionPatron },
  { path: "catalog", title: "Catalog module", markdown: catalogReadme },
  { path: "circulation", title: "Circulation module", markdown: circulationReadme },
  {
    path: "public-opac",
    title: "Public OPAC API integration",
    markdown: publicOpacGuide,
  },
];

export const DOC_BY_PATH: Record<string, DocEntry> = (() => {
  const map: Record<string, DocEntry> = {};
  for (const entry of DOC_INDEX) {
    map[entry.path] = entry;
    if (entry.path === "") {
      map["README.md"] = entry;
    } else {
      map[`${entry.path}/README.md`] = entry;
      map[`${entry.path}.md`] = entry;
    }
  }
  return map;
})();
